/* 21Captains theme JS — keep small, no jQuery, no build step */
(function () {
  'use strict';

  // === Sticky header scroll behaviour ================================
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // === Mobile drawer =================================================
  var drawer = document.querySelector('[data-mobile-drawer]');
  var toggle = document.querySelector('[data-menu-toggle]');
  var backdrop = document.querySelector('[data-mobile-drawer-backdrop]');
  var closeBtn = document.querySelector('[data-mobile-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (toggle) toggle.addEventListener('click', openDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  // === Generic accordion =============================================
  document.querySelectorAll('[data-accordion-group]').forEach(function (group) {
    var single = group.hasAttribute('data-accordion-single');
    group.querySelectorAll('[data-accordion]').forEach(function (acc) {
      var header = acc.querySelector('[data-accordion-header]');
      if (!header) return;
      header.addEventListener('click', function () {
        var wasOpen = acc.classList.contains('is-open');
        if (single) {
          group.querySelectorAll('[data-accordion]').forEach(function (other) {
            other.classList.remove('is-open');
          });
        }
        acc.classList.toggle('is-open', !wasOpen);
      });
    });
  });

  // === Generic gallery thumbnail switcher ============================
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    if (!main) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (!src) return;
        main.src = src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  });

  // === FAQ search filter =============================================
  var faqSearch = document.querySelector('[data-faq-search]');
  if (faqSearch) {
    faqSearch.addEventListener('input', function () {
      var q = this.value.trim().toLowerCase();
      document.querySelectorAll('[data-faq-item]').forEach(function (item) {
        var text = (item.textContent || '').toLowerCase();
        item.style.display = (q === '' || text.indexOf(q) > -1) ? '' : 'none';
      });
      document.querySelectorAll('[data-faq-category]').forEach(function (cat) {
        var anyVisible = Array.prototype.some.call(
          cat.querySelectorAll('[data-faq-item]'),
          function (i) { return i.style.display !== 'none'; }
        );
        cat.style.display = anyVisible ? '' : 'none';
      });
    });
  }

  // === FAQ category nav ==============================================
  document.querySelectorAll('[data-faq-cat-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-faq-cat-btn'));
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      document.querySelectorAll('[data-faq-cat-btn]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
    });
  });

  // === UGC video player ==============================================
  document.querySelectorAll('[data-ugc-tile]').forEach(function (tile) {
    tile.addEventListener('click', function () {
      var inner = tile.querySelector('[data-ugc-inner]');
      var existing = inner && inner.querySelector('video');
      if (existing) return;
      var src = tile.getAttribute('data-video');
      if (!src) return;
      var img = inner.querySelector('img');
      if (img) img.style.display = 'none';
      var video = document.createElement('video');
      video.autoplay = true; video.muted = true; video.loop = true; video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.style.cssText = 'width:100%;height:100%;object-fit:cover;position:absolute;inset:0;';
      var source = document.createElement('source');
      source.src = src; source.type = 'video/mp4';
      video.appendChild(source);
      inner.appendChild(video);
      var playBtn = tile.querySelector('[data-ugc-play]');
      if (playBtn) playBtn.style.display = 'none';
    });
  });

  // === Featured-products colour swatch image swap ===================
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-swatch-image]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('[data-product-card]');
    if (!card) return;
    var mainImg = card.querySelector('[data-card-image]');
    if (!mainImg) return;
    var newSrc = sw.getAttribute('data-swatch-image');
    if (!newSrc) return;
    mainImg.src = newSrc;
    var siblings = card.querySelectorAll('[data-swatch-image]');
    for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-active');
    sw.classList.add('is-active');
  });

  // === Product variant picker ========================================
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsScript = form.querySelector('[data-variants]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var hiddenInput = form.querySelector('[data-variant-input]');
    var atcBtn = form.querySelector('[data-atc-btn]');
    var atcText = form.querySelector('[data-atc-text]');
    var priceEl = form.querySelector('[data-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var colourLabel = form.querySelector('[data-colour-label]');

    function formatMoney(cents) {
      var dollars = (cents / 100);
      return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
    }

    function getActiveOptions() {
      var groups = {};
      form.querySelectorAll('[data-variant-option]').forEach(function (btn) {
        var idx = btn.getAttribute('data-option-index');
        if (!groups[idx]) groups[idx] = null;
        if (btn.classList.contains('is-active')) groups[idx] = btn.getAttribute('data-option-value');
      });
      var keys = Object.keys(groups).sort();
      return keys.map(function (k) { return groups[k]; });
    }

    function update() {
      var active = getActiveOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return active[i] == null || opt === active[i];
        });
      });
      if (!match) return;
      if (hiddenInput) hiddenInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);
      if (atcBtn) atcBtn.disabled = !match.available;
      if (atcText) {
        atcText.textContent = match.available
          ? 'Add to Cart · ' + match.title + ' ' + formatMoney(match.price)
          : 'Between batches';
      }
      if (colourLabel && match.option2) colourLabel.textContent = match.option2;
    }

    form.querySelectorAll('[data-variant-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-option-index');
        form.querySelectorAll('[data-variant-option][data-option-index="' + idx + '"]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        update();
      });
    });
  });

  // === Add-to-Cart drawer ============================================
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var drawerImage = cartDrawer && cartDrawer.querySelector('[data-drawer-image]');
  var drawerTitle = cartDrawer && cartDrawer.querySelector('[data-drawer-title]');
  var drawerVariant = cartDrawer && cartDrawer.querySelector('[data-drawer-variant]');
  var drawerPrice = cartDrawer && cartDrawer.querySelector('[data-drawer-price]');
  var drawerSubtotal = cartDrawer && cartDrawer.querySelector('[data-drawer-subtotal]');
  var cartCountEl = document.querySelector('[data-cart-count]');
  var lastFocusedBeforeDrawer = null;

  function formatCents(cents) {
    var dollars = (cents || 0) / 100;
    var s = dollars.toFixed(2).replace(/\.00$/, '');
    return '$' + s;
  }

  function openCartDrawer(addedItem, cart) {
    if (!cartDrawer) return;
    if (drawerImage) {
      drawerImage.src = addedItem.image || (addedItem.featured_image && addedItem.featured_image.url) || '';
      drawerImage.alt = addedItem.product_title || addedItem.title || '';
    }
    if (drawerTitle) drawerTitle.textContent = addedItem.product_title || addedItem.title || '';
    if (drawerVariant) {
      var variantText = '';
      if (addedItem.variant_title && addedItem.variant_title !== 'Default Title') {
        variantText = addedItem.variant_title;
      }
      drawerVariant.textContent = variantText;
      drawerVariant.style.display = variantText ? '' : 'none';
    }
    if (drawerPrice) drawerPrice.textContent = formatCents(addedItem.final_line_price || addedItem.line_price || addedItem.price);
    if (drawerSubtotal) drawerSubtotal.textContent = formatCents((cart && cart.total_price) || 0);
    if (cartCountEl && cart) cartCountEl.textContent = cart.item_count;

    lastFocusedBeforeDrawer = document.activeElement;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtnEl = cartDrawer.querySelector('.cart-drawer__close');
    if (closeBtnEl) setTimeout(function () { closeBtnEl.focus(); }, 100);
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocusedBeforeDrawer && typeof lastFocusedBeforeDrawer.focus === 'function') {
      lastFocusedBeforeDrawer.focus();
    }
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-cart-drawer-close]')) {
        closeCartDrawer();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCartDrawer();
    });
  }

  // === Global product-form interceptor ==============================
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    if (form.action.indexOf('/cart/add') === -1) return;
    if (!cartDrawer) return;

    e.preventDefault();

    var atcBtn = form.querySelector('[type="submit"]');
    var originalText = null;
    if (atcBtn) {
      atcBtn.disabled = true;
      var span = atcBtn.querySelector('[data-atc-text]');
      if (span) {
        originalText = span.textContent;
        span.textContent = 'Adding...';
      }
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) { throw err; });
        }
        return res.json();
      })
      .then(function (added) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            openCartDrawer(added, cart);
          });
      })
      .catch(function (err) {
        if (err && err.description) {
          window.alert(err.description);
        } else {
          form.submit();
        }
      })
      .then(function () {
        if (atcBtn) {
          atcBtn.disabled = false;
          var span = atcBtn.querySelector('[data-atc-text]');
          if (span && originalText !== null) span.textContent = originalText;
        }
      });
  });

})();